import { AxiosRequestConfig } from "axios";

import { createApiQueryHook } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IEducationalBrief } from "../types/IEducationalBrief";

export interface IEducationalBriefQueryParameters {
    educationalBrief: RelationalValue<IEducationalBrief>;
}

export type IEducationalBriefQueryResult = IEducationalBrief;

export const educationalBriefQuery = ({
    educationalBrief,
}: IEducationalBriefQueryParameters): AxiosRequestConfig | undefined => {
    if (!educationalBrief) {
        return;
    }

    return {
        method: "GET",
        url: `/educational_briefs/${mapRelationalValue(educationalBrief)}`,
    };
};

export const useEducationalBriefQuery = createApiQueryHook<
    IEducationalBriefQueryParameters,
    IEducationalBriefQueryResult
>(educationalBriefQuery);
